<template>
  <div class="footer-layout">
    <div class="left">
      <h2>Footer layout</h2>
      <p>
        Choose your footer layout. Depending on columns number you will have
        different number of widget areas for footer column widgets
      </p>
    </div>
    <div class="right">
      <ColumnSelect
        :columnNumber="3"
        label="Three columns"
        @activeSelect="handleActiveSelect"
        :selectedColumnSet="selectedColumnSet"
      />
      <ColumnSelect
        :columnNumber="4"
        label="Four columns"
        @activeSelect="handleActiveSelect"
        :selectedColumnSet="selectedColumnSet"
      />
      <ColumnSelect
        :columnNumber="5"
        label="Five columns"
        @activeSelect="handleActiveSelect"
        :selectedColumnSet="selectedColumnSet"
      />
    </div>
  </div>
</template>

<script>
import ColumnSelect from "./ColumnSelectComponent.vue";
export default {
  components: {
    ColumnSelect,
  },
  props: {
    selectedColumnSet: {
      type: Number,
    },
  },
  methods: {
    handleActiveSelect(data) {
      this.$emit("selectedColumnSet", data);
    },
  },
};
</script>

<style scoped lang='scss'>
.footer-layout {
  max-width: 940px;
  display: flex;
  align-items: center;
  .left {
    max-width: 430px;
    h2 {
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: #001529;
      margin: 0 0 15px 0;
    }
    p {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #001529;
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    .col-select-wrap {
      position: relative;
      height: 90px;
      .overlay {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .col-select {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 150px;
        height: 60px;
        border: 1px solid #cbcbe4;
        padding: 5px;
        margin: 0 0 10px 0;
        cursor: pointer;
        &.selected {
          border-color: #2295d6;
        }
        div {
          background: #cbcbe4;
          flex-basis: 100%;
          text-align: center;
          border: 1px solid #fff;
          height: 100%;
          margin: 0 1px;
        }
      }
      span {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #001529;
      }
      img {
        position: absolute;
        width: 20px;
        left: calc(100% - 10px);
        bottom: calc(100% - 5px);
      }
    }
  }
}
</style>